export const STEP_TRACKER_SET_DATA = 'STEP_TRACKER_SET_DATA';
export const STEP_TRACKER_INCREMENT = 'STEP_TRACKER_INCREMENT ';
export const STEP_TRACKER_DECREMENT = 'STEP_TRACKER_DECREMENT ';